export default __webpack_public_path__ + "414efa6d77701ff12fc5d0bc3fe93bdd.svg";